import { Client } from 'braintree-web';
import { CardPayment } from './types';

interface GetCardsProps {
    defaultFirst?: boolean;
}

export async function getCards(client: Client, { defaultFirst = false }: GetCardsProps = {}) {
    return new Promise<CardPayment[]>((res, rej) =>
        client.request(
            {
                endpoint: 'payment_methods',
                method: 'get',
                data: {
                    defaultFirst,
                },
            },
            (err, data) => {
                if (err) {
                    rej(err);
                    return;
                }

                const cards = data.paymentMethods.filter((method: any) => method.type === 'CreditCard');
                res(cards);
            },
        ),
    );
}

export interface DeleteCardProps {
    singleUseTokenId: string;
}

const DELETE_PAYMENT_METHOD_MUTATION = `mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {
    deletePaymentMethodFromSingleUseToken(input: $input) {
        clientMutationId
    }
}
`;

export async function deleteCard(client: Client, { singleUseTokenId }: DeleteCardProps) {
    return new Promise((res, rej) =>
        client.request(
            {
                // api property is supported option based on braintree-web/client/client.js#270
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                api: 'graphQLApi',
                data: {
                    query: DELETE_PAYMENT_METHOD_MUTATION,
                    variables: {
                        input: {
                            singleUseTokenId,
                        },
                    },
                    operationName: 'DeletePaymentMethodFromSingleUseToken',
                },
            },
            (err, data) => {
                if (err) {
                    rej(err);
                    return;
                }
                res(data);
            },
        ),
    );
}
